export default __webpack_public_path__ + "static/media/greatestpizza.ddb0efdb.PNG";